<template>
  <div class="FillUserInfoViewContainer">
    <nut-row class="shadow box colFlex pd16">
      <nut-input
          v-model="data.phone"
          style="padding: 16px 0"
          label="手机号"
          placeholder="请输入手机号"
          clearable
          @clear="data.phone=''"
      >
      </nut-input>
      <nut-input
          v-model="data.captcha"
          style="padding: 16px 0"
          label="验证码"
          placeholder="请输入验证码"
          clearable
          @clear="data.captcha=''"
      >
        <template #button>
          <nut-button size="small"
                      :disabled="timeout > 0"
                      @click="send">{{ timeout > 0 ? timeout + 's' : '发送验证码' }}
          </nut-button>
        </template>
      </nut-input>
      <nut-row class="bothCenter mt24">
        <button class="submitBtn wft ft16 vpd8 brd8" @click="submit">绑定</button>
      </nut-row>
    </nut-row>
  </div>
</template>

<script>
import api from "@/api";
import {Toast} from "@nutui/nutui";

export default {
  name: "FillUserInfoView",
  data() {
    return {
      timeout: 0,
      data: {
        phone: '',
        captcha: '',
      },
      timer: null,
    }
  },
  methods: {
    send() {
      let thiz = this;
      api.applySmsCaptcha(this.data.phone)
          .then(() => {
            this.timeout = 60;
            this.timer = setInterval(() => {
              thiz.timeout -= 1;
              if (thiz.timeout <= 0) {
                clearInterval(thiz.timer);
              }
            }, 1000)
          })
    },
    submit() {
      api.applySmsBind({
        phone: this.data.phone,
        code: this.data.captcha,
      }).then(() => {
        Toast.success('绑定成功!')
        this.$router.go(-1)
      })
    },
    init() {
      api.getUserInfo()
          .then(ret => {
            this.data = ret;
          })
    }
  },
  mounted() {
    this.init()
  },
  unmounted() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss" scoped>
.FillUserInfoViewContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;


  .submitBtn {
    border: none;
    background: #E76A2C;
    width: 240px;
  }
}
</style>